import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { GallectionSourceType } from '../../../../../types/gallection';
import { ExhibitionistBoxType } from '../ExhibitionistBox';
import EmptyState from '../../../EmptyState';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';

import s from './ExhibitionistEmptyState.scss';

export interface Props {
  moduleId: number;
  className?: string;
  exhibitionistType: ExhibitionistBoxType;
  view: 'large' | 'small' | 'wide';
  isOwner: boolean;
  username: string;
  sourceType: GallectionSourceType;
}

export class ExhibitionistEmptyState extends React.Component<
  Props & WithTranslation & WithVerificationProps
> {
  render() {
    const {
      className,
      view,
      isOwner,
      username,
      sourceType,
      exhibitionistType,
      t,
    } = this.props;

    const { buttonLabel, onButtonClick } = this.getCTAButtonAttrs();

    return (
      <EmptyState
        view={view}
        className={classnames(
          className,
          s[`${exhibitionistType}_${sourceType}`]
        )}
        title={
          isOwner
            ? t!(
                `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.title.owner`
              )
            : t!(
                `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.title.visitor`,
                {
                  username,
                }
              )
        }
        subtitle={
          isOwner
            ? t!(
                `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.subtitle.owner`
              )
            : t!(
                `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.subtitle.visitor`,
                { username }
              )
        }
        buttonLabel={buttonLabel}
        onButtonClick={onButtonClick}
        withButton={isOwner}
      />
    );
  }

  getCTAButtonAttrs = () => {
    const { sourceType, exhibitionistType, t } = this.props;
    switch (sourceType) {
      case GallectionSourceType.PRINTS:
        return {
          buttonLabel: t!(
            `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.CTALabel.owner`
          ),
          onButtonClick: this.navigateToSubmitPrint,
        };

      case GallectionSourceType.COLLECTION:
        return {
          buttonLabel: t!(
            `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.CTALabel.owner`
          ),
          onButtonClick: this.navigateToBrowse,
        };

      default:
        return {
          buttonLabel: t!(
            `widgets.exhibitionist.${exhibitionistType}.${sourceType}.empty.CTALabel.owner`
          ),
          onButtonClick: this.navigateToSubmit,
        };
    }
  };

  navigateToSubmit = () => {
    const { isVerificationNeeded, pushVerificationPopup } = this.props;
    if (isVerificationNeeded) {
      pushVerificationPopup('submit');
      return;
    }

    window.location.replace(URLS.SUBMIT);
  };
  navigateToBrowse = () => {
    window.location.replace(URLS.ROOT);
  };
  navigateToSubmitPrint = () => {
    const { isVerificationNeeded, pushVerificationPopup } = this.props;
    if (isVerificationNeeded) {
      pushVerificationPopup('submit');
      return;
    }

    window.location.replace(URLS.SUBMIT);
  };
}

export default withVerification(withTranslation()(ExhibitionistEmptyState));
